var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"mask-loading hvc",on:{"touchmove":_vm.preventEvents}},[_c('img',{staticClass:"loading-gif",attrs:{"src":"https://resource.rcclchina.com.cn/Home/mb_loading.gif","alt":"loading"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }